import React from 'react'
import RouteAdminFeaturesGroupsIndex from './groups/index'
import RouteAdminFeaturesGroupsNew from './groups/new'
import RouteAdminFeaturesGroup from './group'
import { Route, Switch } from 'react-router-dom'

const RouteAdminFeaturesGroups = ({ match: { path } }) => (
  <Switch>
    <Route path={path} exact component={RouteAdminFeaturesGroupsIndex} />
    <Route path={`${path}/new`} component={RouteAdminFeaturesGroupsNew} />
    <Route path={`${path}/:groupId`} component={RouteAdminFeaturesGroup} />
  </Switch>
)

export default RouteAdminFeaturesGroups



// WEBPACK FOOTER //
// ./src/routes/admin/features/groups.js